import {PermissionM} from "./permission.model";

export class UserM{
  id:number = 0;
  no:string = '';
  ref_no:string = ""
  user_id:number = 0;
  branch_id:number = 0;
  branch_name:string = ""
  username:string = '';
  firstname:string = '';
  lastname:string = '';
  email:string = '';
  password:string = '';
  confirm_password:string = '';
  type:string = '';
  type2:string = 'general';
  idcard_pic:string = '';
  verified:number = 0;
  perm:PermissionM = new PermissionM();
  status:string = "";
  address:string = '';
  birthday:string = '';
  profile_youtube_id:string = '';
  youtube_intro:string = '';
  profile_video_name:string = '';
  email_reset:string = '';
  gender:string = '';
  age:number = 0;
  resetPasswordToken:string = '';
  idcard_no:string = '';
  idcard_address:string = '';
  profile_completed:number = 0;
  edu_completed:number = 0;
  id_completed:number = 0;
  bank_book_pic:string = '';
  avatar:string = '';
  mobile:string = '';
  firstLogin = 0;
  firstCreateCourse = 0;
  fb_email:string = '';
  bank_id:number = 0;
  bank_name:string = '';
  bank_branch:string = '';
  bank_account_name:string = ''
  bank_account_no:string = '';
  emailC:string = 'email';
  store_name:string = ""
  tax_no:string = ""
  phone:string = ""
  sender:any;
  receiver:any;
  school:string = '';
  remark:string = ''
  tax_id:string = ""
  debit:0
  credit:0
  balance:0
  ready2Teach:boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/model/user.model.ts